// extracted by mini-css-extract-plugin
module.exports = {"container_wrapper":"CardText_container_wrapper__kCQvr","kicker":"CardText_kicker__LBY9f","title":"CardText_title__KZKan","button-wrapper":"CardText_button-wrapper__Y1aQh"};